import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { compose, withStateHandlers } from "recompose";
import { save } from "actions/riskmedicalActions";
import { load as loadCart } from "actions/checkoutActions";
import { loadAccountWallet } from "actions/cartActions";
import { getCartInfo } from "./cartSelectors";
import Wallet from "./Wallet";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { get } from "lodash";
import accounting from "accounting";
import stickyfill from "stickyfill";
import MiniWallet from "./MiniWallet";

const Stickyfill = stickyfill();
class Cart extends PureComponent {
  componentDidMount() {
    let effectiveDate = null;
    const { loadAccountWallet, loadCart, type, planStart } = this.props;

    if (type === "benefits") {
      // Only apply for enrolment
      // Get the account effectiveDate to be deducted
      effectiveDate = planStart;
    }

    // planYear,
    // effectiveDate,
    // includingHidden
    Promise.all([loadCart(), loadAccountWallet(null, effectiveDate, true)]);
  }

  checkout = () => {
    const { type, selectionToSave, save, push } = this.props;

    if (type === "benefits" && selectionToSave.length > 0) {
      save(selectionToSave, true);
    } else {
      push("/shop/checkout");
    }
  };

  onRefInit = ref => {
    if (!ref) {
      Stickyfill.remove(this.ref);
    }
    this.ref = ref;
    this.addSticky();
  };

  addSticky = () => {
    this.ref && Stickyfill.add(this.ref);
  };

  componentWillUnmount() {
    this.ref && Stickyfill.remove(this.ref);
  }

  render() {
    if (this.props.fetching) {
      return null;
    }

    const {
      cart,
      type,
      allowOverpurchase: overpurchaseOption,
      saving,
      intl,
      common,
      isNarrowScreen,
      isMiniWalletExpanded,
      toggleMiniWalletExpanding,
      ...cartProps
    } = this.props;

    const { enable: allowOverpurchase, limit } = overpurchaseOption;
    const overpurchaseLimit = (limit && Number.parseFloat(limit)) || 0;
    const {
      account,
      balance,
      accountType,
      totalBreakdown,
      subTotal,
      remaining,
      overPurchase,
    } = cart[type];

    if (balance === null || typeof balance === "undefined") {
      return null;
    }

    const periodEnd = account && (account.periodEnd || "");
    const planId = account && account.planId;
    const { isShopEnabled, isEnrolmentEnabled } = common;
    const showGraph = isShopEnabled && isEnrolmentEnabled;

    const isPurchaseAllowed =
      overPurchase <= 0 ||
      (allowOverpurchase && (overpurchaseLimit < 0 || overPurchase < overpurchaseLimit));

    const remainingBalance = overPurchase ? -overPurchase : remaining;
    // construct data for Wallet component
    const itemTypes = totalBreakdown
      .map(({ id, title, total }) => ({
        name: id,
        id: intl.formatMessage({
          id: title,
          defaultMessage: title,
        }),
        value: total,
        percentage: accounting.unformat(accounting.toFixed((total / subTotal) * 100, 2)),
      }))
      // As of latest requirement, always show "benefits". "wellness" is conditional
      .filter(i => i.name === "benefits" || (i.name === "wellness" && isShopEnabled));

    const walletData = {
      walletName: intl.formatMessage(messages.walletDescription),
      walletExpand: intl.formatMessage(messages.wellnessWalletExpandDescription),
      walletCollapse: intl.formatMessage(messages.wellnessWalletCollapseDescription),
      totalPrefix: intl.formatMessage(messages.wellnessWalletNowHaveDescription),
      selectedPrefix: intl.formatMessage(messages.wellnessWalletHaveSelectedDescription),
      buttonText: intl.formatMessage(messages.checkoutDescription),
      subtext: intl.formatMessage(messages.gstDescription),
      totalBalance: balance,
      spentAmount: subTotal,
      href: `/claims/accounts/${planId}/${accountType}/${
        periodEnd ? encodeURIComponent(periodEnd) : ""
      }`,
      linkTitle: intl.formatMessage(messages.accountInfoDescription),
      isShowingButton: isPurchaseAllowed,
      isSaving: saving,
      items: itemTypes,
      currency: get(account, "currency", ""),
      remainingText: intl.formatMessage(messages.remainingBalanceDescription),
      remainingBalance,
      balanceRatio: remainingBalance / balance,
      toggleMiniWalletExpanding,
      isMiniWalletExpanded,
      isNarrowScreen,
    };

    const { onRefInit } = this;

    return !isMiniWalletExpanded && isNarrowScreen ? (
      <MiniWallet
        {...cartProps}
        {...walletData}
        toggleMiniWalletExpanding={toggleMiniWalletExpanding}
        onClick={this.checkout}
      />
    ) : (
      <div className="apl-cart sticky" ref={onRefInit}>
        <div>
          <Wallet
            {...walletData}
            toggleMiniWalletExpanding={toggleMiniWalletExpanding}
            showGraph={showGraph}
            onClick={this.checkout}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.error,
  allowOverpurchase: state.cart.allowOverpurchase,
  isAuthenticated: state.login.isAuthenticated,
  selectionToSave: state.riskmedical.selectionToSave,
  saving: state.riskmedical.saving,
  fetching: state.riskmedical.fetching,
  summary: state.riskmedical.summary,
  cart: getCartInfo(state),
  common: state.common,
});

const mapDispatchToProps = {
  save,
  loadCart,
  loadAccountWallet,
};

Cart.propTypes = {
  push: PropTypes.func,
  items: PropTypes.object,
  balance: PropTypes.number,
  wellness: PropTypes.number,
  benefits: PropTypes.number,
  available: PropTypes.number,
  allowOverpurchase: PropTypes.object,
  overpurchaseLimit: PropTypes.number,
  enrolmentAccount: PropTypes.object,
  checkout: PropTypes.func,
  selectionToSave: PropTypes.array,
  save: PropTypes.func,
  saving: PropTypes.bool,
  loadRiskMedical: PropTypes.func,
  loadAccountWallet: PropTypes.func,
  loadCart: PropTypes.func,
  cart: PropTypes.object,
  type: PropTypes.string,
  fetching: PropTypes.bool,
  intl: intlShape.isRequired,
  currency: PropTypes.object,
  common: PropTypes.object,
  isNarrowScreen: PropTypes.bool,
  planStart: PropTypes.string,
  isMiniWalletExpanded: PropTypes.bool,
  toggleMiniWalletExpanding: PropTypes.func,
};

const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStateHandlers(
    ({ isMiniWalletExpanded }) => ({
      isMiniWalletExpanded: isMiniWalletExpanded || false,
    }),
    {
      toggleMiniWalletExpanding: ({ isMiniWalletExpanded }) => () => ({
        isMiniWalletExpanded: !isMiniWalletExpanded,
      }),
    }
  )
);

export default enhance(Cart);



// WEBPACK FOOTER //
// ./components/employee/shop/Cart.js